import { render, staticRenderFns } from "./tas-detail.vue?vue&type=template&id=33d95bb2&scoped=true&"
import script from "./tas-detail.vue?vue&type=script&lang=js&"
export * from "./tas-detail.vue?vue&type=script&lang=js&"
import style0 from "./tas-detail.vue?vue&type=style&index=0&id=33d95bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d95bb2",
  null
  
)

export default component.exports